export default "__VITE_ASSET__kBy7$w_G__"